import * as React from 'react';
import { TooltipCommonProps } from '../common';

export type StackedBarChartItem = {
  label: string;
  values: number[];
};

export interface StackedBarChartProps {
  /** Applied as data-hook HTML attribute that can be used in the tests. */
  dataHook?: string;
  /**
   * Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  /** Chart data. */
  data?: StackedBarChartItem[];
  /** Tooltip template function. */
  tooltipTemplate?: (item: StackedBarChartItem) => React.ReactNode;
  /**
   * Props that modify the Tooltip created from text bar charts.
   * @linkTypeTo components-overlays--tooltip
   * @setTypeName TooltipCommonProps
   */
  tooltipCommonProps?: TooltipCommonProps;
  /** Chart width (px).
   * @default 900
   */
  width?: number;
  /** Chart height (px).
   * @default 350
   */
  height?: number;
  /** Margin (px) for each side of the Chart. For example, in order to render larger number of digits at the yAxis, increase the left margin prop. */
  margin?: { top: number; left: number; bottom: number; right: number };
  /**
   * ##### Formats Y axis ticks
   *  * `param` {string} `rawValue` - a raw value e.g. 10000
   *  * `param` {string} `rawValue` - number formatted value, comma separated e.g. 10,000
   *  * `return` {string} - the value to be shown as Y axis tick
   */
  yAxisTickFormat?: (rawValue: string, parsedValue: string) => string;
  weight?: number;
}
